import { FulfillmentEventT } from "../types/Fulfillment";
import { FulfillmentT } from "../types/Fulfillment";

export const transformFulfillmentDataToEvents = (
  fulfillmentDates: FulfillmentT[]
): FulfillmentEventT[] => {
  return fulfillmentDates.map((ts) => {
    const fulfillmentDate = new Date(ts.fulfillment_date);
    const start = new Date(
      fulfillmentDate.getTime() + fulfillmentDate.getTimezoneOffset() * 60000
    );

    return {
      id: ts.fulfillment_date,
      title: ts.fulfillment_date,
      start: start,
      count_customers: ts.count_customers,
      count_deliveries: ts.count_deliveries,
      count_volume_upgrades: ts.count_volume_upgrades || 0,
      fulfillment_date: ts.fulfillment_date,
    };
  });
};
